import CsvButton from "../buttons/csvButton";
import ExcelButton from "../buttons/excelButton";
import PdfButton from "../buttons/pdfButton";

const PackButtonsExport = ({
  data, //Los datos que necesitas para crear las tablas en los archivos PDF y excel
  dataCopy, //Una copia del array original para poder hacer el filtro bien, ya que estamos manejando los datos del padre
  setData, //Para setear los datos en la tabla
  titleProps, //Título En la hoja del PDF
  headers, //Nombre de las columnas
  properties, //Propiedades de los objetos que le pasamos
  name, //Nombre del archivo al descargar(no incluir el .pdf o .csv)
  filtros, //La propiedad del objeto por la que se va a aplicar el filtro
  placeholderInput, //PlaceHolder del input de
  csv = true,
  pdf = true,
  excel = true,
  setCurrentPage,
  inputSearch,
  exportButtons,
}) => {
  const handleChangeInput = (event) => {
    setCurrentPage(1);
    let terminoBusqueda = event.target.value;
    const dataFilter = dataCopy.filter((dato) => {
      return filtros.some((f) => {
        return dato[f]
          .toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase());
      });
    });
    setData(dataFilter);
  };

  return (
    <div
      className={`d-flex px-3 ${
        inputSearch ? "justify-content-between" : "justify-content-end"
      } mb-2 mt-2`}
    >
      {inputSearch && (
        <label className="bg-white border border-secondary inputSearch rounded p-1">
          <span className="mdi mdi-magnify "></span>
          <input
            className="ml-1 border-0 w-75"
            onChange={(event) => handleChangeInput(event)}
            placeholder={placeholderInput}
          />
        </label>
      )}
      {exportButtons && (
        <span>
          {" "}
          {excel && (
            <ExcelButton
              headers={headers}
              data={data}
              name={name}
              properties={properties}
            ></ExcelButton>
          )}
          {pdf && (
            <PdfButton
              titleProps={titleProps}
              headers={headers}
              data={data}
              properties={properties}
              name={name}
            ></PdfButton>
          )}
          {csv && (
            <CsvButton
              data={data}
              properties={properties}
              name={name}
            ></CsvButton>
          )}
        </span>
      )}
    </div>
  );
};

export default PackButtonsExport;
